import {AnyAction} from 'redux';
import {REMOVE_ALL_POWER_SOURCE_TYPE, REMOVE_STATIONS} from '../action';


/**
 * remove all power sources of a given type
 */
export function removePowerSourceType(source_type: string) : AnyAction
{
    return {type: REMOVE_ALL_POWER_SOURCE_TYPE, payload: {source_type}};
}


export function removePowerSources(stations: boolean[]) : AnyAction
{
    return {type: REMOVE_STATIONS, payload: {stations}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/power-sources/removePowerSources.ts